import { render } from "./impostos.vue?vue&type=template&id=684532de"
import script from "./impostos.vue?vue&type=script&lang=js"
export * from "./impostos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__